import { unref as _unref, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InputArea from '@/components/neue/InputArea.vue'
import InputField from '@/components/neue/InputField.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { DESCRIPTION_HELP, sectionCopy } from '@/config/membershipTierWizardSteps'


export default {
  __name: 'StepName',
  setup(__props) {

const wizard = injectWizard()

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('details', _unref(wizard).data))), {
    default: _withCtx(() => [
      _createVNode(InputField, {
        modelValue: _unref(wizard).data.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.name) = $event)),
        name: "Name",
        autofocus: ""
      }, null, 8, ["modelValue"]),
      _createVNode(InputArea, {
        modelValue: _unref(wizard).data.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(wizard).data.description) = $event)),
        name: "Description",
        description: _unref(DESCRIPTION_HELP),
        rows: "3"
      }, null, 8, ["modelValue", "description"])
    ]),
    _: 1
  }, 16))
}
}

}